// extracted by mini-css-extract-plugin
module.exports = {"row":"row---6uVx","rowInner":"rowInner--tHoA-","box":"box--WCmeB"};